<template>
  <div class="executeTime">
    <el-row :gutter="15">
      <el-col :span="executeTime.operator != 'equal' ? 10 : 24">
        <NormalSelect
          size="normal"
          :selectList="operators"
          :selectedItem.sync="executeTime.operator"
          @update:selectedItem="changeExtra"
        ></NormalSelect>
      </el-col>
      <!-- 选择当前日期时间时不显示 -->
      <el-col v-if="executeTime.operator != 'equal'" :span="8">
        <el-input v-model="executeTime.number" @blur="changeExtra"></el-input>
      </el-col>
      <el-col v-if="executeTime.operator != 'equal'" :span="6">
        <NormalSelect
          size="normal"
          :selectList="units"
          :selectedItem.sync="executeTime.unit"
          @update:selectedItem="changeExtra"
        ></NormalSelect>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import NormalSelect from "@/components/UIComponents/NormalSelect"

export default {
  name: "executeTime",
  components: {
    NormalSelect
  },
  props: {
    executeTime: Object
  },
  data() {
    return {
      defaultTime: new Date(2019, 10, 10, 8, 0, 0),
      units: [
        {
          label: "分钟",
          value: "minute"
        },
        {
          label: "小时",
          value: "hour"
        },
        {
          label: "天",
          value: "day"
        }
      ]
    }
  },
  computed: {
    operators() {
      let operators = [
        {
          label: "之前",
          value: "before"
        },
        {
          label: "之后",
          value: "after"
        }
      ]
      if (this.executeTime.controlType == "time") {
        operators.unshift({
          label: "指定的日期时间",
          value: "equal"
        })
      }
      return operators
    }
  },
  methods: {
    changeExtra() {
      this.$emit("change")
    }
  }
}
</script>

<style lang="scss">
.executeTime {
  margin-top: 10px;
  .selectList {
    margin-top: 0;
    .el-input .el-input__inner {
      border-width: 1px;
    }
  }
  .timePicker {
    width: 212.5px;
  }
}
</style>
